<template>
    <div>
        <component
            :is="componentTypes[layersShape.type]"
            v-for="(layersShape, key) in items"
            :id="key"
            :key="key"
            :shape="layersShape"
            :current-locale="currentLocale"
            :aspect-ratio="aspectRatio"
            :image-size="imageSize"
            :zoom="zoom"
            :shape-created-callback="shapeCreatedCallback"
            :breakpoint="breakpoint"
            :extra-scale="extraScale"
            :style="
                draggingState || layersShape.static ? 'pointerEvents: none' : ''
            "
            :class="
                draggingState || layersShape.static
                    ? 'disable-pointer-events'
                    : ''
            "
            @handleMouseDownVue="handleMouseDownVue($event, key)"
            @handleMouseUpVue="handleMouseUpVue($event, key)"
            @handleMouseMoveVue="handleMouseMoveVue($event, key)"
            @handleContextMenuVue="handleContextMenuVue($event, key)"
            @handleFrameClickVue="handleFrameClickVue($event, key)"
            @handleMouseOverVue="handleMouseOverVue($event, key)"
            @handleMouseLeaveVue="handleMouseLeaveVue($event, key)"
            @touchstart="handleMouseDownVue($event, key)"
            @touchmove="handleMouseMoveVue($event, key)"
            @touchend="handleMouseUpVue($event, key)"
            @touchcancel="handleMouseLeaveVue($event, key)"
        />
    </div>
</template>

<script>
import Label from "../components/tools/Label";
import Pin from "../components/tools/Pin";
import LabelIcon from "../components/tools/LabelIcon";
import LabelNav from "../components/tools/LabelNav";

export default {
    name: "CanvasLayers",
    props: {
        imageSize: {
            type: Object,
            required: true,
        },
        aspectRatio: {
            type: Number,
            required: true,
        },
        zoom: {
            type: Number,
            required: true,
        },
        extraScale: {
            type: Number,
            required: false,
            default: 1,
        },
        items: {
            type: [Object, Array],
            required: true,
        },
        breakpoint: {
            type: Number,
            default: 7,
        },
        currentLocale: {
            type: Number | String,
            required: false,
            default: 0,
        },
        draggingState: {
            type: [Boolean, Number],
            default: false,
        },
        shapeCreatedCallback: {
            type: Function,
            required: false,
        },
    },

    components: {
        Label,
        Pin,
        LabelIcon,
        LabelNav,
    },
    data() {
        return {
            componentTypes: {
                pin: "Pin",
                label: "Label",
                labelIcon: "LabelIcon",
                labelNav: "LabelNav",
            },
        };
    },

    methods: {
        handleMouseOverVue(event, key) {
            this.$emit("handleMouseOverVue", { event, key });
        },
        handleMouseLeaveVue(event, key) {
            this.$emit("handleMouseLeaveVue", { event, key });
        },
        handleMouseMoveVue(event, key) {
            this.$emit("handleMouseMoveVue", { event, key });
        },

        handleMouseDownVue(event, key) {
            this.$emit("handleMouseDownVue", { event, key });
        },

        handleMouseUpVue(event, key) {
            this.$emit("handleMouseUpVue", { event, key });
        },

        handleContextMenuVue(event, key) {
            this.$emit("handleContextMenuVue", { event, key });
        },
        handleFrameClickVue(event, key) {
            this.$emit("handleFrameClickVue", { event, key });
        },
    },
};
</script>

<style scoped></style>
